import { render, staticRenderFns } from "./DeleteSupportConfirmation.vue?vue&type=template&id=a82dc2e4&"
import script from "./DeleteSupportConfirmation.vue?vue&type=script&lang=js&"
export * from "./DeleteSupportConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports